"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTool02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16.5 1a6.5 6.5 0 0 0-6.39 7.696L7 5.586V3a1 1 0 0 0-.684-.949l-3-1a1 1 0 0 0-1.023.242l-1 1a1 1 0 0 0-.242 1.023l1 3A1 1 0 0 0 3 7h2.586l3.5 3.5-6.293 6.293a3.121 3.121 0 1 0 4.414 4.414L12 16.414l4.793 4.793a3.121 3.121 0 1 0 4.414-4.414l-3.015-3.015a6.503 6.503 0 0 0 4.543-8.12 1 1 0 0 0-1.666-.424L19.083 7.21c-.242.24-.363.36-.49.429a1 1 0 0 1-.952-.001c-.128-.07-.248-.19-.489-.431s-.361-.362-.43-.489a1 1 0 0 1-.002-.952c.069-.128.19-.248.43-.49l2.146-2.158a1 1 0 0 0-.327-1.632A6.484 6.484 0 0 0 16.5 1Z", fill: "currentColor" }) }))); };
exports.default = SvgTool02;
